export default __webpack_public_path__ + "static/media/subversion.c851494b.svg";